module.exports = __webpack_public_path__ + "bn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bn.svg
// module id = 712
// module chunks = 0